import cn from 'classnames'
import { FC, MouseEvent, ReactNode } from 'react'

import styles from './styles.module.scss'

type ButtonModes = 'primary' | 'secondary' | 'green' | 'gray' | 'icon'

type ButtonProps = {
    value?: string
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void
    disabled?: boolean
    mode?: ButtonModes
    isLoading?: boolean
    withoutShadow?: boolean
    className?: string
    dataTestId?: string
    postfixElement?: ReactNode
    prefixElement?: ReactNode
}

export const Button: FC<ButtonProps> = ({
    value,
    onClick,
    disabled,
    mode = 'primary',
    isLoading,
    withoutShadow,
    className,
    dataTestId,
    postfixElement,
    prefixElement,
}) => (
    <button
        onClick={onClick}
        className={cn(styles.button, className, {
            [styles.button_shadowless]: withoutShadow,
            [styles.button_disabled]: disabled || isLoading,
        })}
        disabled={disabled || isLoading}
        data-test-id={dataTestId}
        data-mode={mode}
    >
        {isLoading ? (
            <div className={styles.button__loader} />
        ) : (
            <>
                {prefixElement && (
                    <div className={styles['button__prefix-element']}>
                        {prefixElement}
                    </div>
                )}
                {value && <span className={styles.button__title}>{value}</span>}
                {postfixElement && (
                    <div className={styles['button__postfix-element']}>
                        {postfixElement}
                    </div>
                )}
            </>
        )}
    </button>
)
